import { SignupNotificationEmails } from '@/types';
import client from './client';

async function get() {
  const { data } = await client.get<SignupNotificationEmails>(`/signupNotificationEmails`);
  return data;
}

async function add({ email }: { email: string }) {
  const { data } = await client.patch<SignupNotificationEmails>(`/signupNotificationEmails`, {
    email,
  });
  return data;
}

async function remove({ email }: { email: string }) {
  const { data } = await client.delete<SignupNotificationEmails>(`/signupNotificationEmails`, {
    params: { email },
  });
  return data;
}

export const signupNotificationEmails = {
  get,
  add,
  remove,
};
